// address type strings
export const TO_ADDRESS_KIND = 'to';
export const SENDER_ADDRESS_KIND = 'sender';
export const RETURN_ADDRESS_KIND = 'return';

// address book names
export const BATCH_BAR_ADDRESS_BOOK = 'batch-bar';
export const RATE_WARNINGS_ADDRESS_BOOK = 'RATE_WARNINGS_ADDRESS_BOOK';

// required fields based on country to be consider completed address in Address form.
export const ADDRESS_INPUT_FIELDS = {
  minRequireFields: ['street1', 'city', 'zip', 'country'], // all other countries
  requireStateField: ['street1', 'city', 'state', 'zip', 'country'], // ['US', 'CA', 'IE'] are countries that requires state field
  requireStreetNumberSuffix: ['street1', 'streetNumber', 'city', 'zip', 'country'], // ['DE', 'AT', 'CH'] are countries that requires street1 and street2 fields
};
